/**
 * Created by razial on 07.12.2022
 */

const TreasureBagIcon = cc.Node.extend({
    ctor: function () { 
        this._super();

        const styles = cleverapps.styles.TreasureBag;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(styles);

        if (styles.background) {
            const background = new cc.Sprite(bundles.treasurebag.frames.treasurebag_bg_png);
            background.setAlignment(this.width / 2, this.height / 2);
            this.addChild(background);
        }

        const animation = this.animation = new cleverapps.Spine(bundles.treasurebag.jsons.treasurebag_json);
        animation.setAlignment(styles.animation);
        this.addChild(animation);

        cleverapps.aims.registerTarget("default", this, {
            withoutDelta: true,
            controls: ["treasureBag"]
        });
        this.setLocalZOrder(TreasureBagIcon.ZORDER);

        this.onResize();
    },

    onResize: function () {
        const styles = cleverapps.styles.TreasureBag;
        this.setScale(connector.info.isMobile ? styles.mobileScale[cleverapps.resolution.mode] : styles.scale[cleverapps.resolution.mode]);
        this.baseScale = this.scale;
        this.setAlignment(styles.position);
    },

    onShow: function () {
        this.animation.setAnimation(0, "animation", false);
    }
});

TreasureBagIcon.ZORDER = WindowComponent.WINDOWS_ZORDER + 1;

cleverapps.styles.TreasureBag = {
    width: 210,
    height: 210,
    scale: [0.8, 1, 1],
    mobileScale: [0.65, 0.8, 0.8],

    animation: {
        x: { align: "center", dx: -2 },
        y: { align: "center", dy: -8 }
    },

    position: {
        x: { align: "right", dx: -10 },
        y: { align: "bottom", dy: 200 }
    },

    hideVertical: false,

    offsetY: 60,

    background: true
};